import React, { useState } from "react";
import styles from "../../assets/styles/Feedback/Feedback.module.scss";
import { Formik } from "formik";
import { MimaButton, MimaDropdown, MimaInput, MimaText, ReceiptCheckBox as RCB, Modal } from "../../components";
import moment from "moment";
import { feedbackStore } from "../../stores";
import { close } from "../../components/Button/styles";


const ActivateFeedback = ({
    data,
    loading,
    onSubmit,
    closeModal,
    validationSchema,
}) => {

    const featureList = feedbackStore.feedbackKey.filter(y => y.status === true).map(x => {
        return {
            key: x.key,
            value: x.key
        }
    })

    return (
        <Modal closeModal={closeModal}>
            <MimaText variant="subtitleBold" align="center" mb="7">Activate Configuration</MimaText>
            <MimaText variant="body" align="center" mb={4} width="38">Are you sure you want to activate Feedback Configuration for <span style={{ color: "var(--color-primary)", fontWeight: "700" }}>{data.key}</span> feature?</MimaText>
            <Formik
                initialValues={{
                    status: true,
                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    values,
                    errors,
                    touched
                }) => (
                    <div style={{ display: "flex", gap: "2rem", }}>
                        <MimaButton
                            title="Activate"
                            variant="small"
                            onClick={handleSubmit}
                            loading={loading}
                        />
                        <MimaButton
                            title="Cancel"
                            variant="small"
                            onClick={closeModal}
                            buttonColor="var(--color-dark-3)"
                        />
                    </div>
                )}

            </Formik>

        </Modal>
    )
}
export default ActivateFeedback;